<template>
	<div>
		<h1 class="vrnu-headline">Texte</h1>
    <vrnu-text-box v-bind:variant="'info'">
      In der Textverwaltung können einzelne Texte, die statisch in der App hinterlegt sind, bearbeitet werden.
      Bitte informieren Sie sich, wo in der App ein bestimmter Text angezeigt wird und welche Auswirkungen das Löschen oder Bearbeiten des Textes eventuell hat,
      bevor Sie Änderungen an diesem vornehmen.
    </vrnu-text-box>
    <vrnu-list-wizard 	v-bind:listData="listData"
							v-on:delete="deleteText"
							v-on:saveSuccess="saveSuccess"
							v-on:saveError="saveError"></vrnu-list-wizard>
							
		<!-- Info modal -->
		<b-modal ref="infoModal" centered hide-footer title="Info">
			<p>{{ infoModalMessage }}</p>
			<slot name="modal-ok">
				<b-button class="vrnu-button" v-on:click="$refs.infoModal.hide()">Ok</b-button>
			</slot>
	    </b-modal>	    
	</div>
</template>

<script>
import ListWizard from '@/components/99_wizards/ListWizard';

export default {
	data: function() {
		return {
			texts: [],
			infoModalMessage: null,
			listData: {
				name: "Text",
				confirmAttribute: 'ident',
				formModule: 'vrnu-texts-form',
				viewModule: 'vrnu-texts-view',
				target: 'texts',
				pagination: true,
				filter: true,
				fields: [
					{
						key: 'ident',
						label: 'Ident',
						sortable: true						
					},
					{
						key: 'headline',
						label: 'Überschrift',
						sortable: true						
					},
					{
						key: 'text',
						label: 'Text',
						sortable: false,
						formatter: function(value) {
              if (value.length > 20) {
                value = value.substring(0, 20) + " ...";
              }
              return value;
						},
					},
				],
				actions: [
					{
						type: 'view',
						text: 'Text öffnen',
						icon: 'icon-eye',
					},
					{
						type: 'update',
						text: 'Text bearbeiten',
						icon: 'icon-pencil',
					},
					{
						type: 'delete',
						text: 'Text löschen',
						icon: 'icon-trash',
						// target: '/text/deleteTextManually/{id}',
					},
				],
			},
		};
	},
	methods: {
		getTexts: function() {
			// Get texts from server
			this.$http.get('texts').then(texts => {
				this.texts = texts.body;
			}, response => {
				// TODO: find solution
				// this.texts = "Es ist ein Fehler aufgetreten. Bitte wenden Sie sich an den Systemadministrator!";
			});
		},
		deleteText: function(id) {
			// Get texts from server
			this.$http.delete('texts/' + id).then(response => {
				var textName = response.body.headline + ' (' + response.body.ident + ')';
				this.openInfoModal("Der Text \"" + textName + "\" wurde erfolgreich gelöscht.");
			}, response => {
				this.openInfoModal("Beim Löschen des Texts ist ein Fehler aufgetreten. Bitte wenden Sie sich an den Systemadministrator.");
			});
		},
		saveSuccess: function(result) {
			this.openInfoModal("Der Text \"" + result.body.headline + " (" + result.body.ident + ")\" wurde erfolgreich gespeichert.");
		},
		saveError: function(response) {
			this.openInfoModal("Beim Speichern des Texts ist ein Fehler aufgetreten. Bitte wenden Sie sich an den Systemadministrator.");
		},
		openInfoModal: function(message) {
			this.infoModalMessage = message;
			this.$refs.infoModal.show();
		},
	},
	created: function() {
		// Get texts from server and display them
		this.getTexts();
	},
	components: {
		'vrnu-list-wizard': ListWizard,
	}
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/11_text/Texts.vue